import type { SVGProps } from "react";

export const Splunk = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    style={{}}
    version="1.1"
    viewBox="0 0 458 136"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    y="0px"
    {...props}
  >
    <title>Splunk</title>

    <g>
      <path
        d="M48.8,82.4c0,3-0.6,5.8-1.9,8.4c-1.3,2.6-3.1,4.8-5.4,6.6c-2.3,1.8-5.1,3.2-8.2,4.2c-3.2,1-6.7,1.5-10.4,1.5
		c-4.5,0-8.6-0.6-12.1-1.9C7.2,100,3.6,97.9,0,95.1l5.9-9.7c2.8,2.4,5.4,4.1,7.7,5.2c2.3,1.1,4.6,1.6,7,1.6c3,0,5.3-0.7,7.1-2.3
		c1.8-1.5,2.7-3.6,2.7-6.2c0-1.1-0.2-2.1-0.5-3.1c-0.3-1-0.9-2-1.8-3c-0.9-1-2.1-2.1-3.6-3.3c-1.5-1.2-3.5-2.7-5.9-4.4
		c-1.8-1.3-3.6-2.6-5.4-4c-1.7-1.4-3.3-2.9-4.8-4.4c-1.4-1.6-2.6-3.3-3.5-5.3c-0.9-1.9-1.3-4.2-1.3-6.6c0-2.9,0.6-5.5,1.8-7.8
		c1.2-2.4,2.8-4.3,4.9-6c2.1-1.7,4.5-3,7.4-3.9c2.9-0.9,6-1.4,9.4-1.4c3.6,0,7,0.5,10.4,1.4c3.3,1,6.4,2.4,9.3,4.2l-5.4,8.7
		c-3.7-2.6-7.5-3.9-11.6-3.9c-2.5,0-4.5,0.6-6.1,1.9c-1.6,1.3-2.4,2.9-2.4,4.8c0,1.9,0.7,3.5,2.1,5c1.4,1.5,3.9,3.5,7.4,6.2
		c3.5,2.6,6.4,4.8,8.7,6.8c2.3,1.9,4.1,3.8,5.5,5.5c1.4,1.7,2.2,3.4,2.8,5.2C48.6,78.3,48.8,80.2,48.8,82.4z M109.9,66.1
		c0,2.7-0.3,5.6-0.9,8.7c-0.5,3.1-1.5,6-2.8,8.6c-1.4,2.6-3.1,4.8-5.3,6.5c-2.2,1.7-4.9,2.6-8.3,2.6c-5.6,0-9.9-2.2-13.1-6.7
		c-3.2-4.4-4.8-10.5-4.8-18.2c0-7.9,1.6-14.2,4.9-18.9c3.2-4.7,7.7-7,13.2-7c5.3,0,9.4,2.2,12.5,6.6
		C108.4,52.5,109.9,58.5,109.9,66.1z M129.2,65.4c0-5.2-0.7-9.9-2.2-14.1c-1.5-4.2-3.6-7.9-6.3-10.9c-2.7-3.1-5.9-5.4-9.7-7.1
		c-3.7-1.7-7.9-2.6-12.4-2.6c-5,0-9.4,1-13.1,2.8c-3.8,1.9-7.3,4.8-10.5,8.9l-0.1-10.1H57.1V136h17.7V92.2c1.7,2,3.4,3.7,5.1,5.1
		c1.6,1.4,3.2,2.5,4.9,3.4c1.7,0.9,3.4,1.5,5.3,1.9c1.9,0.4,3.8,0.5,5.9,0.5c4.7,0,9.1-1,13.2-2.8c4.1-1.9,7.6-4.5,10.5-7.9
		c3-3.4,5.3-7.4,6.9-11.9C128.4,75.8,129.2,70.8,129.2,65.4z M137.1,101.4h18.2V0h-18.2V101.4z M233.1,101.5V32.3h-18.2v37.2
		c0,3.3-0.1,5.9-0.4,7.7c-0.3,1.8-0.7,3.4-1.4,4.9c-2.6,5.7-7.3,8.6-14.2,8.6c-5.4,0-9.1-1.9-11.2-5.8c-0.9-1.5-1.4-3.1-1.7-5
		c-0.3-1.9-0.5-4.5-0.5-8.1V32.3h-18.2v39.3c0,2.7,0,5,0.1,6.8c0,1.8,0.2,3.5,0.4,4.9c0.2,1.4,0.4,2.7,0.6,3.8
		c0.2,1.1,0.6,2.2,1,3.2c1.7,4.2,4.3,7.4,8.1,9.6c3.7,2.2,8.3,3.2,13.7,3.2c4.9,0,9.2-0.9,12.9-2.6c3.7-1.7,7.3-4.5,10.8-8.4l0,9.3
		L233.1,101.5z M311.6,101.4V62.2c0-2.7,0-5-0.1-6.8c0-1.9-0.1-3.5-0.4-4.9c-0.2-1.4-0.4-2.6-0.7-3.6c-0.3-1.1-0.6-2.1-1-3.1
		c-1.7-4.1-4.3-7.3-8.1-9.6c-3.7-2.2-8.3-3.4-13.8-3.4c-4.9,0-9.2,0.9-12.9,2.6c-3.7,1.7-7.3,4.5-10.8,8.4l0-9.3h-18.3v69.1H264
		V64.2c0-3.2,0.1-5.7,0.4-7.5c0.2-1.8,0.7-3.5,1.3-5.1c1.2-2.8,3-4.8,5.5-6.3c2.5-1.4,5.4-2.1,8.8-2.1c5.4,0,9.1,1.9,11.2,5.8
		c0.8,1.5,1.4,3.1,1.7,5c0.3,1.8,0.5,4.5,0.5,8v39.4L311.6,101.4z M387,96.9l-27.8-34.5l23.5-25.2l-13.8-6l-24.4,28.3h-1.9V0h-18.4
		v101.4h18.4V64.7l27.5,38.1L387,96.9z M458,72.1V60.8L402.7,33v12.4l42.8,20.8l-42.8,21.1v12.2L458,72.1z M408.1,15.1
		c-3.4,0-6.1,2.8-6.1,6.2c0,3.5,2.7,6.2,6.1,6.2c3.4,0,6.1-2.7,6.1-6.2C414.2,17.9,411.5,15.1,408.1,15.1z M408.1,16.1
		c2.7,0,4.9,2.4,4.9,5.3c0,2.9-2.2,5.3-4.9,5.2c-2.8,0-5-2.3-5-5.3C403.1,18.4,405.3,16.1,408.1,16.1z M406.9,22h0.7
		c0.9,0,1.3,0.3,1.5,1.2c0.1,0.9,0.3,1.5,0.5,1.7h1.2c-0.1-0.2-0.3-0.6-0.4-1.7c-0.1-1-0.5-1.6-1.2-1.7v-0.1
		c0.7-0.2,1.4-0.8,1.4-1.7c0-0.6-0.2-1.1-0.6-1.4c-0.4-0.3-1.1-0.5-2.1-0.5c-0.8,0-1.4,0.1-2,0.2v6.9h1.1V22z M406.9,18.7
		c0.2,0,0.4-0.1,0.8-0.1c1.2,0,1.7,0.6,1.7,1.2c0,0.9-0.8,1.2-1.7,1.2h-0.8V18.7z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default Splunk;
